<template>
  <div class="container">
    <header>
      <img :src="require('@/assets/images/brand.png')">
      <h3>{{businessName}}</h3>
      <a-tooltip :arrowPointAtCenter="true">
        <template slot="title">
          {{shopInfo | formatShopInfo}}
        </template>
        <span>关联店铺</span>
      </a-tooltip>
    </header>
    <main>
      <div class="item">
        <label>商家ID：</label>
        <span>{{businessId}}</span>
      </div>
      <div class="item">
        <label>品牌：</label>
        <span>{{virturalBrandList | formatBrand}}</span>
      </div>
      <div class="item">
        <label>子品牌：</label>
        <div class="subbrand">
          <span v-line-clamp="4">{{subBrandList | formatBrand}}</span>
          <span class="showall" @click="showallBrands" v-if="subBrandList.length>0">查看全部</span>
        </div>
      </div>
      <div class="item">
        <label>K币余额：</label>
        <span class="money">{{amount | formatAmount}}</span>
      </div>
      <a-button type="primary" class="recharge-btn" @click="gotoRecharge">去充值</a-button>
    </main>
    <CommonModal
      title="子品牌"
      :footer="null"
      width="400px"
      :visible="visible"
      @cancel="handleCancel"
      :bodyStyle="{ padding: '0 20px' }"
    >
      <div class="brand-item" v-for="(v) in subBrandList" :key="v.brandCode">
        {{v.brandCode}} {{v.brandName}}
      </div>
    </CommonModal>
  </div>
</template>
<script>
  import { Button, Tooltip } from 'ant-design-vue'
  import CommonModal from '@/components/common-modal'
  import _ from 'lodash'
  export default {
    name: 'brand-info',
    components: {
      [Button.name]: Button,
      [Tooltip.name]: Tooltip,
      CommonModal
    },
    data() {
      return {
        visible: false,
        businessId: '',
        businessName: '',
        amount: '',
        shopInfo: {},
        virturalBrandList: [],
        subBrandList: []
      }
    },
    created() {
      this.queryBrandBusinessInfo()
    },
    methods: {
      async queryBrandBusinessInfo() {
        const res = await this.$store.dispatch('brandHome/queryBrandBusinessInfo')
        console.log('queryBrandBusinessInfo====>', res)
        if (res && +res.code === 1 && res.data) {
          this.businessId = _.get(res, ['data', 'businessId']) || ''
          this.businessName = _.get(res, ['data', 'businessName']) || ''
          this.amount = _.get(res, ['data', 'amount']) || ''
          this.shopInfo = _.get(res, ['data', 'shopInfo']) || {}
          this.virturalBrandList = _.get(res, ['data', 'virturalBrandList']) || []
          this.subBrandList = _.get(res, ['data', 'subBrandList']) || []
        }
      },
      gotoRecharge() {
        const PROTOCOL = process.env.VUE_APP_SEVERENV === 'BETA' ? 'http' : 'https'
        const RECHARGE_URL = `${PROTOCOL}://open.haiziwang.com/platform/?link=${PROTOCOL}://ad.haiziwang.com/pure/account/x/addCredit/add/outside&hide=true`
        window.open(RECHARGE_URL)
      },
      showallBrands() {
        this.visible = true
      },
      handleCancel() {
        this.visible = false
      }
    },
    filters: {
      formatBrand(v) {
        if (Array.isArray(v) && v.length > 0) {
          return v.map(item => `${item.brandCode} ${item.brandName}`).join('、')
        } else {
          return '-'
        }
      },
      formatAmount(v) {
        if (isNaN(v)) {
          return '-'
        } else {
          return (+v / 100).toFixed(2)
        }
      },
      formatShopInfo(v) {
        console.log('formatShopInfo====>', v)
        const shopId = _.get(v, 'shopId')
        const shopName = _.get(v, 'shopName')
        if (shopId && shopName) {
          return `${shopName}(${shopId})`
        } else {
          return '您暂未绑定店铺，请联系运营'
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  .container {
    background: #ffffff;
    height: 100%;
    header {
      display: flex;
      align-items: center;
      padding: 10px 20px 3px 7px;
      border-bottom: 1px solid #f6f6f6;
      h3 {
        font-size: 16px;
        font-weight: 500;
        margin-left: 5px;
        margin-right: 18px;
      }
      span {
        font-size: 14px;
        font-weight: 400;
        color: #1c7ae5;
        cursor: pointer;
      }
      img {
        height: 40px;
      }
    }
    main {
      padding: 20px;
      .item {
        display: flex;
        margin-bottom: 12px;
        font-size: 14px;
        label {
          /* width: 85px; */
          flex-shrink: 0;
          color: #333333;
          font-weight: 400;
        }
        span {
          color: #000000;
        }
        span.money {
          color: #1c7ae5;
          font-weight: 500;
        }
        span.showall {
          font-size: 14px;
          color: #1c7ae5;
          font-weight: 400;
          position: absolute;
          cursor: pointer;
          right: 0;
        }
        .subbrand {
          position: relative;
          width: 100%;
          /* margin-bottom: 10px; */
        }
      }
      .recharge-btn {
        width: 82px;
        height: 28px;
        border-radius: 3px;
        margin-top: 6px;
      }
    }
  }
  .brand-item {
    padding: 12px 0;
    border-bottom: 1px solid #eeeeee;
    font-size: 14px;
    color: #333333;
  }
</style>
